import React from 'react';

import {
  BaseModalFooter,
  BaseModal,
  BaseModalProps,
} from 'components/wrappers/BaseModal';
import {
  CompanyProfileFormValues,
  mapCompanyProfileToRequest,
} from './CompanyProfileForm/mapUtils';
import BaseAlert from 'components/wrappers/BaseAlert';
import CompanyProfileForm from './CompanyProfileForm';
import SubmitButton from 'components/formik/SubmitButton';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import {
  FullBOUserResponseModel,
  ProfileTypeEnum,
} from 'api/backofficeApiClient';
import { saveCompanyGeneralInfo } from 'redux/reducers/accountSlice';
import { saveRecruiterCompanyGeneralInfo } from 'redux/reducers/recruiterSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  formRef: any;
  onSuccess: () => Promise<void>;
  isAdmin?: boolean;
  modalProps: BaseModalProps;
  profileInfo?: FullBOUserResponseModel;
};

export default function CompanyProfileModal(props: Props) {
  const { formRef, isAdmin, modalProps, profileInfo, onSuccess } = props;
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: CompanyProfileFormValues) => {
    const data = mapCompanyProfileToRequest(values, profileInfo);

    const correctAction = isAdmin
      ? saveRecruiterCompanyGeneralInfo
      : saveCompanyGeneralInfo;

    const result = await dispatch(correctAction(data));

    if (correctAction.fulfilled.match(result)) {
      await onSuccess();

      BaseAlert.success('Profile changes saved.');
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <BaseModal {...modalProps}>
      <CompanyProfileForm
        formRef={formRef}
        onSubmit={handleSubmit}
        profileInfo={profileInfo}
        profileType={profileInfo?.profileType as ProfileTypeEnum}
        formFooter={
          <BaseModalFooter>
            <SubmitButton>Save</SubmitButton>
          </BaseModalFooter>
        }
      />
    </BaseModal>
  );
}
